/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ExternalApiMonitoringList } from '../models/external-api-monitoring-list';
import { getExternalApisMonitoring } from '../fn/external-ap-is-monitoring/get-external-apis-monitoring';
import { GetExternalApisMonitoring$Params } from '../fn/external-ap-is-monitoring/get-external-apis-monitoring';


/**
 * All about getting infos about the monitoring of external APIs
 */
@Injectable({ providedIn: 'root' })
export class ExternalApIsMonitoringService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getExternalApisMonitoring()` */
  static readonly GetExternalApisMonitoringPath = '/external-apis/monitoring';

  /**
   * Get the current status of the external APIs monitoring.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExternalApisMonitoring()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExternalApisMonitoring$Response(params?: GetExternalApisMonitoring$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalApiMonitoringList>> {
    return getExternalApisMonitoring(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the current status of the external APIs monitoring.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExternalApisMonitoring$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExternalApisMonitoring(params?: GetExternalApisMonitoring$Params, context?: HttpContext): Observable<ExternalApiMonitoringList> {
    return this.getExternalApisMonitoring$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExternalApiMonitoringList>): ExternalApiMonitoringList => r.body)
    );
  }

}
